// extracted by mini-css-extract-plugin
export default {"formWrapper":"Form_formWrapper__Pjbju","form":"Form_form__psS5c","form__textField":"Form_form__textField__oTM4w","form__annotation":"Form_form__annotation__0S03b"};